import Link, { type LinkProps } from '@mui/material/Link';
import { forwardRef } from 'react';
import {
  Link as ReactRouterLink,
  type LinkProps as ReactRouterLinkProps,
} from 'react-router';

export type RouterLinkProps = LinkProps & ReactRouterLinkProps;

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  (props, ref) => <Link ref={ref} component={ReactRouterLink} {...props} />,
);

if (process.env.NODE_ENV !== 'production') {
  RouterLink.displayName = 'RouterLink';
}
